<form (ngSubmit)="upload()" [formGroup]="loadForm">
    <div style="width: 500px">
        <div class="title">Upload</div>

        <app-alert/>

        <div class="label">Upload Type:</div>
        <select formControlName="uploadType" class="field">
            <option [value]="UploadType.Round">Round</option>
            <option [value]="UploadType.Snapshot">Snapshot</option>
        </select>

        <div class="label">{{ installIdOrLoginLabel() }}</div>
        <input autofocus class="field" formControlName="installIdOrLogin" required type="text">

        <custom-dropzone (fileSelected)="onFileSelected($event)"/>

        <button [disabled]="!loadForm.valid || isLoading" class="button" type="submit">
            <span [hidden]="isLoading">Submit</span>
            <img [hidden]="!isLoading" alt="Loading" src="../../../assets/img/spinner.svg"/>
        </button>
    </div>
</form>